// https://babeljs.io/blog/2019/03/19/7.4.0#migration-from-core-js-2
import * as smoothscroll from 'smoothscroll-polyfill'

import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './index'

smoothscroll.polyfill()
